import React from 'react';

type StatusType = 'match' | 'novo' | 'ausente' | 'anomalia' | 'activo' | 'liquidado' | 'alterado' | 'valido' | 'erro' | 'pendente';

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  size?: 'sm' | 'md';
}

const statusConfig: Record<StatusType, { label: string; className: string }> = {
  match: { label: 'Coincide', className: 'bg-positive-subtle text-positive border border-green-200' },
  novo: { label: 'Novo', className: 'bg-info-subtle text-[color:var(--info)] border border-blue-200' },
  ausente: { label: 'Ausente', className: 'bg-warning-subtle text-warning-color border border-amber-200' },
  anomalia: { label: 'Anomalia', className: 'bg-negative-subtle text-negative border border-red-200' },
  activo: { label: 'Activo', className: 'bg-positive-subtle text-positive border border-green-200' },
  liquidado: { label: 'Liquidado', className: 'bg-muted text-muted-foreground border border-border' },
  alterado: { label: 'Alterado', className: 'bg-warning-subtle text-warning-color border border-amber-200' },
  valido: { label: 'Válido', className: 'bg-positive-subtle text-positive border border-green-200' },
  erro: { label: 'Erro', className: 'bg-negative-subtle text-negative border border-red-200' },
  pendente: { label: 'Pendente', className: 'bg-warning-subtle text-warning-color border border-amber-200' },
};

export default function StatusBadge({ status, label, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status];
  const displayLabel = label ?? config.label;
  const sizeClass = size === 'sm' ? 'text-[11px] px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${sizeClass} ${config.className}`}>
      {displayLabel}
    </span>
  );
}